/* Nuuke — passerelle entre les sections tw-* (script classique) et les événements standards du thème
   Horizon (modules ES). Permet à la buy box d'ouvrir le tiroir du panier au lieu d'envoyer sur /cart.
   Si ce fichier ne se charge pas, tw.js retombe sur l'ancien comportement (redirection vers /cart). */
import { CartLinesUpdateEvent } from '@shopify/events';

window.__twCartEvent = CartLinesUpdateEvent;
document.dispatchEvent(new CustomEvent('tw:events-ready'));
